import classNames from 'classnames';
import React from 'react';
import Button from './Button';
import { ButtonColor, ButtonType } from './models/ButtonModels';
import { getClassesForButtonColor, getClassesForButtonType } from './utils/buttonHelpers';

type IconButtonProps = {
  icon: string | React.ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  buttonColor?: ButtonColor;
  hoverText?: string | React.ReactNode;
  tabIndex?: number;
  iconClass?: string;
  className?: string;
  active?: boolean;
  tooltipClass?: string;
  tooltipText?: string;
  tooltipStyle?: React.CSSProperties;
  colors?: string;
};

type IconButtonContainerProps = IconButtonProps & {
  children: React.ReactNode;
};

export default function IconButton(props: IconButtonProps) {
  const classes = classNames(
    props.className,
    getClassesForButtonType(ButtonType.Icon),
    getClassesForButtonColor(props.buttonColor || ButtonColor.White),
    {
      active: props.active
    }
  );

  const Container = (props: IconButtonContainerProps) => {
    if (props.tooltipText) {
      return <span className={`highed-template-tooltip ${props.tooltipClass}`}>{props.children}</span>;
    }
    return <>{props.children}</>;
  };

  return (
    <Container {...props}>
      <Button
        extraClass={classes}
        iconLeft={true}
        buttonText={props.hoverText}
        tabIndex={props.tabIndex}
        icon={props.icon}
        iconClass={props.iconClass}
        onClick={props.onClick}
      />
      {props.tooltipText && (
        <div className={'highed-tooltip-text'} style={props.tooltipStyle}>
          {props.tooltipText}
        </div>
      )}
    </Container>
  );
}
